import React, { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import flvjs from "flv.js";
import { Service } from "utils/services";
import { Maximize, Volume2, VolumeOffIcon } from "lucide-react";

type Props = {
  post: any;
  playerControlRef?: React.MutableRefObject<{
    pause: () => void;
    play: () => void;
    goLive: () => void;
  } | null>;
};

const NewFeedLiveFlv: React.FC<Props> = ({ post, playerControlRef }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const flvPlayerRef = useRef<flvjs.Player | null>(null);

  const { ref: inViewRef, inView } = useInView({ threshold: 0.3 });
  const [isMuted, setIsMuted] = useState(true);

  const createPlayer = () => {
    if (!videoRef.current || flvPlayerRef.current || !flvjs.isSupported()) return;

    const player = flvjs.createPlayer({
      type: "flv",
      url: post.media_url,
      isLive: true,
    });

    player.attachMediaElement(videoRef.current);
    player.load();
    player.play();

    flvPlayerRef.current = player;
  };

  const destroyPlayer = () => {
    if (flvPlayerRef.current) {
      flvPlayerRef.current.destroy();
      flvPlayerRef.current = null;
    }
  };

  useEffect(() => {
    if (!post || !inView) return;

    createPlayer();
    return () => {
      destroyPlayer();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, post?.media_url]);

  // Expose control functions to parent
  useEffect(() => {
    if (!playerControlRef) return;

    playerControlRef.current = {
      pause: () => {
        videoRef.current?.pause();
      },
      play: () => {
        videoRef.current?.play();
      },
      goLive: () => {
        const video = videoRef.current;
        if (video && video.seekable.length > 0) {
          video.currentTime = video.seekable.end(0);
          video.play();
        }
      },
    };
  }, [playerControlRef]);

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = !video.muted;
    setIsMuted(video.muted);
  };

  const width = Service.toDouble(post?.post_attachments?.[0]?.attachment_media_width || 0);
  const height = Service.toDouble(post?.post_attachments?.[0]?.attachment_media_height || 0);
  const ratio = height === 0 ? 1 : width / height;

  return (
    <>
      <style>
        {`
        .player-poster.clickable,
        .player-poster.clickable .play-wrapper,
        .poster-icon {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
      `}
      </style>
      <div>
        <div ref={inViewRef} className="w-full max-h-[500px] relative overflow-hidden mt-2" onClick={(e) => e.stopPropagation()}>
          {/* LIVE Badge */}
          <div className="absolute top-3 right-3 flex space-x-2 z-20">
            <div className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded">LIVE</div>
          </div>

          <div className="w-full max-h-[500px] rounded overflow-hidden" style={ratio >= 0 && ratio < 0.74 ? { height: "500px" } : { aspectRatio: `${ratio}` }}>
            <video ref={videoRef} muted autoPlay playsInline controls={false} className="w-full h-full rounded bg-black" />
          </div>

          {/* Custom Controls */}
          <div className="absolute bottom-4 w-full px-4 flex items-center justify-between text-white z-50 ">
            {/* Left controls: Play + Volume + Slider */}
            <div className="flex items-center space-x-2">
              {/* {isPlaying ? (
              <Pause onClick={togglePlay} className="cursor-pointer rounded-full bg-opacity-10 bg-black p-1 max-sm:size-6 size-8" />
            ) : (
              <Play onClick={togglePlay} className="cursor-pointer rounded-full bg-opacity-10 bg-black p-1 max-sm:size-6 size-8" />
            )} */}

              <div
                className="flex items-center space-x-2"
                onClick={() => {}}
                onMouseMove={() => {
                  // setShowVolumeInput(true);
                }}
                //   onMouseLeave={() => setShowVolumeInput(false)}
              >
                <button className="text-white" onClick={toggleMute}>
                  {isMuted ? (
                    <VolumeOffIcon className="rounded-full bg-opacity-10 bg-black p-1 max-sm:size-6 size-8" />
                  ) : (
                    <Volume2 className="rounded-full bg-opacity-10 bg-black p-1 max-sm:size-6 size-8" />
                  )}
                </button>

                {/* {showVolumeInput && (
                <div className=" bg-black size-5 rounded-2xl bg-opacity-10 text-white max-sm:w-24 w-28 p-2 items-center flex pt-4 pb-4">
                  <input type="range" min={0} max={100} value={volume} onChange={(e) => onSeekVolume(parseFloat(e.target.value))} className="max-sm:w-20 w-24 " />
                </div>
              )} */}
              </div>
            </div>

            {/* <div className="flex items-center space-x-4">
            <button onClick={handleGoLive} className="flex items-center space-x-2 text-white font-semibold">
              <span className={`w-2 h-2 rounded-full ${isLive ? "bg-red-600" : "bg-gray-400"}`} />
              <span>Live</span>
            </button>
            <Maximize onClick={toggleFullscreen} className="cursor-pointer rounded-full bg-opacity-10 bg-black p-1 max-sm:size-6 size-8" />
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewFeedLiveFlv;

